var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCircleQuestion28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.63636C12.795 9.63636 11.8182 10.6132 11.8182 11.8182H9.63636C9.63636 9.40821 11.59 7.45455 14 7.45455C16.41 7.45455 18.3636 9.40821 18.3636 11.8182C18.3636 13.7297 17.1352 15.3514 15.4281 15.9425C15.2938 15.9889 15.1894 16.062 15.1315 16.1261C15.1034 16.1572 15.0938 16.1765 15.0909 16.1847V17.2727H12.9091V16.1818C12.9091 14.9245 13.9169 14.1568 14.7143 13.8807C15.5699 13.5845 16.1818 12.7714 16.1818 11.8182C16.1818 10.6132 15.205 9.63636 14 9.63636Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0909 21.6364V19.4545H12.9091V21.6364H15.0909Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14ZM14 4.18182C8.57757 4.18182 4.18182 8.57757 4.18182 14C4.18182 19.4224 8.57757 23.8182 14 23.8182C19.4224 23.8182 23.8182 19.4224 23.8182 14C23.8182 8.57757 19.4224 4.18182 14 4.18182Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleQuestion28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;